//Library Imports
import React, { useState, useEffect } from "react";
import { Modal, Col, Row, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
//Local Imports
import { RootState } from "store";
import SmallButton from "../../../Content/Shared/SmallButton";
import Input from "../../../../modules/Common/Components/Input";
import SelectWithIcon from "../../../../modules/Campaigns/Shared/SelectWithIcon";
import { ReactComponent as Cross } from "../../../../assets/img/icons/cross.svg";
// actions Imports
import { addNode, clearDropArea, addActionModal, editNode } from "../../actions";
import { ControlNameEnum } from "../../interfaces";
import { findDropAreaData } from "../../utils";
//Style Imports
import styled from "styled-components";

type IWaitModalProps = {
  id: string;
  enableSaveButton: (value: boolean) => void;
};

enum TimeUnits {
  DAYS = "Days",
  HOURS = "Hours",
  MINUTES = "Minutes",
}

const TimeSerializer = {
  d: TimeUnits.DAYS,
  h: TimeUnits.HOURS,
  m: TimeUnits.MINUTES,
};

const { Option } = Select;

const WaitModal = (props: IWaitModalProps) => {
  // Props
  const { id, enableSaveButton } = props;

  // local states
  const [time, setTime] = useState(1);
  const [type, setType] = useState({ value: TimeUnits.DAYS, label: TimeUnits.DAYS });

  // Redux States
  const itemData = useSelector((state: RootState) => state.automation.workflow.flow[id]?.detail);
  const modal = useSelector((state: RootState) => state.automation.modals.addAction);
  const dispatch = useDispatch();

  // Local Variables
  const minutes = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
  const defaultMinutes = 15;

  // Component Logic
  // useEffect to set the data of edit Node
  const isWaitModalOpen = modal.visible === true && modal.tab === ControlNameEnum.WAIT;
  let dependencies = itemData && isWaitModalOpen;
  useEffect(() => {
    if (isWaitModalOpen && itemData) {
      let data: ["", string, "d" | "m" | "h"] = itemData?.delayTime?.split(/(\d+)/);
      if (data?.length > 1) {
        setTime(parseInt(data[1]));
        let timeType = TimeSerializer[data[2]?.trim()];
        setType({ value: timeType, label: timeType });
      }
    }
  }, [dependencies]);

  const closeModal = () => {
    // dispatch(waitModal(false));
    dispatch(addActionModal(false));
    dispatch(clearDropArea());
  };

  const submitHandler = (event: any) => {
    event.preventDefault();
    let data = `${time}${type?.value?.charAt(0)?.toLowerCase()}`;
    let title = ` ${time} ${type.value}`;
    if (id) {
      // edit Node
      dispatch(
        editNode(id, {
          ...itemData,
          delayTime: data,
          nodeTitle: title,
        })
      );
    } else {
      // add node
      let obj = findDropAreaData(ControlNameEnum.WAIT);
      dispatch(
        addNode({
          ...obj,
          delayTime: data,
          nodeTitle: title,
        })
      );
    }
    closeModal();
  };

  const delayTypeChangeHandler = (valueObj: any) => {
    setType(valueObj);
    if (valueObj.value === TimeUnits.MINUTES) {
      setTime(defaultMinutes);
    } else if (valueObj.value === TimeUnits.HOURS) {
      setTime(1);
    } else if (valueObj.value === TimeUnits.DAYS) {
      setTime(1);
    }
  };

  return (
    <Wrapper>
      <div className="label-model">Wait for</div>
      <form id={`${ControlNameEnum.WAIT}`} onSubmit={submitHandler}>
        <div className="wait-wrapper">
          <Row gutter={[32, 0]}>
            <Col span={16} className="left-side">
              {type.value === TimeUnits.MINUTES ? (
                <Select
                  onSelect={(value: number) => {
                    setTime(value);
                  }}
                  defaultValue={defaultMinutes}
                  style={{ width: "100%" }}
                >
                  {minutes.map((time: number) => (
                    <Option key={time} value={time}>
                      {time}
                    </Option>
                  ))}
                </Select>
              ) : (
                <Input
                  type="number"
                  placeholder="Wait for"
                  min="1"
                  step="1"
                  max="9999"
                  value={time}
                  onChange={(e: any) => {
                    const limit = 4;
                    setTime(Math.trunc(e.target.value.slice(0, limit)))
                  }}
                />
              )}
              <div className="limit-text"><label className="note-text" >Note:</label> Please provide a four-digit input.</div>
            </Col>
            <Col span={8}>
              <SelectWithIcon
                defaultValue={{ value: "Days", label: "Days" }}
                value={type}
                onChange={delayTypeChangeHandler}
                options={[
                  { value: TimeUnits.DAYS, label: TimeUnits.DAYS },
                  { value: TimeUnits.HOURS, label: TimeUnits.HOURS },
                  { value: TimeUnits.MINUTES, label: TimeUnits.MINUTES },
                ]}
                menuWidth={120}
              />
            </Col>
          </Row>
          {/* <div className="d-flex justify-content-end mt-4">
              <SmallButton
                onClick={submitHandler}
                title="Save"
              />
            </div> */}
        </div>
      </form>
    </Wrapper>
  );
};

export default WaitModal;

const Wrapper = styled.div`
  .label-model {
    margin-bottom: 24px;
    color: #5e7079;
    font-size: 24px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .wait-wrapper {
    label {
      margin: 0 !important;
    }
    div[class$="-control"] {
      min-width: 100%;
      padding-left: 2px;
      height: 44px;
      border-color: #dadada;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: auto;
      }
    }
    input {
      border-color: #dadada;
      padding-right: 15px;
    }
    .left-side {
      .ant-select-selector {
        height: 44px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: 32px;
        }
      }
    }
  }
  .limit-text{
     font-family: "Roboto";
     font-size: 12px;
     margin-top: 3px;
     color:  #A0A0A0;
     font-style: italic;
   }
   .note-text{
     color: #7E7E7E;
	     font-weight: bold;
   }
`;
